export default "__VITE_ASSET__9ef53ee7__"